import PostLink from "components/blog/PostLink";
import FeaturedPost from "components/blog/FeaturedPost";
import {
  MotionGrid as Grid,
  appearBelow,
  blogFadeIn as fadeIn,
} from "utils/motion";

export default function PostList({
  postsToDisplay,
  showFeaturedPostCondition,
}) {
  if (!postsToDisplay || postsToDisplay.length === 0) {
    return null;
  }

  const actualShowFeaturedPost = showFeaturedPostCondition;

  return (
    <>
      {actualShowFeaturedPost && (
        <FeaturedPost
          variants={appearBelow}
          uid={postsToDisplay[0].uid}
          type={postsToDisplay[0].type}
          data={postsToDisplay[0].data}
          first_publication_date={postsToDisplay[0].first_publication_date}
        />
      )}
      <Grid
        templateColumns={[
          "1fr",
          "repeat(2, 1fr)",
          "repeat(2, 1fr)",
          "repeat(3, 1fr)",
        ]}
        gap={[12, null, "16px"]}
        mt={actualShowFeaturedPost ? 8 : [6, null, 8]}
        variants={fadeIn}
        initial="hidden"
        animate="visible"
      >
        {(actualShowFeaturedPost
          ? postsToDisplay.slice(1)
          : postsToDisplay
        ).map((post) => (
          <PostLink
            color="black.900"
            variants={fadeIn}
            exit="hidden"
            key={post.uid}
            uid={post.uid}
            type={post.type}
            data={post.data}
          />
        ))}
      </Grid>
    </>
  );
}
